import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

// Define the interface for the component's props
interface BoxCornerIconProps {
  icon?: ReactNode;
  left: boolean;
}

// Functional Component using props and state
const BoxCornerIcon: FC<BoxCornerIconProps> = ({ icon, left }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: left ? 0 : undefined,
        right: !left ? 0 : undefined,
        width: '80px', // Adjust size as needed
        height: '80px',
        backgroundColor: '#5e5e5eff', // Example: bright red for visibility
        borderRadius: `${left ? '0 0 16px 0' : '0 0 0 16px'}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '2rem',
        pointerEvents: 'none', // Optional: if you don't want it to block clicks
      }}
    >
      {icon}
    </Box>
  );
};

export default BoxCornerIcon;
